"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.complicationsTypeMessages = exports.devicesTypeMessages = exports.mcsMessages = exports.ComplicationsType = exports.DevicesType = exports.Mcs = void 0;
const schema_1 = require("../../../schema");
var Mcs;
(function (Mcs) {
    Mcs["YES"] = "YES";
    Mcs["NO"] = "NO";
})(Mcs || (exports.Mcs = Mcs = {}));
var DevicesType;
(function (DevicesType) {
    DevicesType["IABP"] = "IABP";
    DevicesType["ECMO"] = "ECMO";
    DevicesType["SHORT_TERM_LVAD"] = "short_term_LVAD";
    DevicesType["SHORT_TERM_RVAD"] = "short_term_RVAD";
    DevicesType["SHORT_TERM_BI_VAD"] = "short_term_BiVAD";
    DevicesType["OTHER_SHORT_TERM_VAD"] = "other_short_term_VAD";
    DevicesType["HEART_WARE_HVAD"] = "HeartWare_HVAD";
    DevicesType["HEART_MATE_II"] = "HeartMate_II";
    DevicesType["HEART_MATE3"] = "HeartMate3";
    DevicesType["JARVIK_2000"] = "Jarvik_2000";
    DevicesType["OTHER_LONG_TERM_VAD"] = "other_long_term_VAD";
})(DevicesType || (exports.DevicesType = DevicesType = {}));
var ComplicationsType;
(function (ComplicationsType) {
    ComplicationsType["OBSTRUCTION"] = "obstruction";
    ComplicationsType["BLEEDING"] = "bleeding";
    ComplicationsType["EMBOLISM"] = "embolism";
    ComplicationsType["DRIVELINE_INFECTION"] = "driveline_infection";
    ComplicationsType["INTRATHORACIC_INFECTION"] = "intrathoracic_infection";
    ComplicationsType["OTHER"] = "other";
})(ComplicationsType || (exports.ComplicationsType = ComplicationsType = {}));
exports.mcsMessages = {
    [Mcs.YES]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.mcs.YES",
        defaultMessage: "Igen"
    },
    [Mcs.NO]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.mcs.NO",
        defaultMessage: "Nem"
    }
};
exports.devicesTypeMessages = {
    [DevicesType.IABP]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.IABP",
        defaultMessage: "IABP"
    },
    [DevicesType.ECMO]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.ECMO",
        defaultMessage: "ECMO"
    },
    [DevicesType.SHORT_TERM_LVAD]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.SHORT_TERM_LVAD",
        defaultMessage: "Rövidtávú LVAD"
    },
    [DevicesType.SHORT_TERM_RVAD]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.SHORT_TERM_RVAD",
        defaultMessage: "Rövidtávú RVAD"
    },
    [DevicesType.SHORT_TERM_BI_VAD]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.SHORT_TERM_BI_VAD",
        defaultMessage: "Rövidtávú BiVAD"
    },
    [DevicesType.OTHER_SHORT_TERM_VAD]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.OTHER_SHORT_TERM_VAD",
        defaultMessage: "Egyéb rövidtávú mechanikus keringéstámogató eszköz"
    },
    [DevicesType.HEART_WARE_HVAD]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.HEART_WARE_HVAD",
        defaultMessage: "HeartWare HVAD"
    },
    [DevicesType.HEART_MATE_II]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.HEART_MATE_II",
        defaultMessage: "HeartMate II"
    },
    [DevicesType.HEART_MATE3]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.HEART_MATE3",
        defaultMessage: "HeartMate3"
    },
    [DevicesType.JARVIK_2000]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.JARVIK_2000",
        defaultMessage: "Jarvik 2000"
    },
    [DevicesType.OTHER_LONG_TERM_VAD]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.devicesType.OTHER_LONG_TERM_VAD",
        defaultMessage: "Egyéb hosszútávú keringéstámogató eszköz"
    }
};
exports.complicationsTypeMessages = {
    [ComplicationsType.OBSTRUCTION]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.complicationsType.OBSTRUCTION",
        defaultMessage: "Obstrukció"
    },
    [ComplicationsType.BLEEDING]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.complicationsType.BLEEDING",
        defaultMessage: "Vérzés"
    },
    [ComplicationsType.EMBOLISM]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.complicationsType.EMBOLISM",
        defaultMessage: "Embólia"
    },
    [ComplicationsType.DRIVELINE_INFECTION]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.complicationsType.DRIVELINE_INFECTION",
        defaultMessage: "Driveline infekció"
    },
    [ComplicationsType.INTRATHORACIC_INFECTION]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.complicationsType.INTRATHORACIC_INFECTION",
        defaultMessage: "Intrathorakális infekció"
    },
    [ComplicationsType.OTHER]: {
        id: "htx.currentCardiologicalState.heartAssistSystemTherapy.complicationsType.OTHER",
        defaultMessage: "Egyéb"
    }
};
const mcs = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Mcs.YES),
    schema_1.Schema.singleChoiceItem(Mcs.NO)
]).interpretation({ vocab: "htx", code: "mcs" });
const devicesType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DevicesType.IABP),
    schema_1.Schema.singleChoiceItem(DevicesType.ECMO),
    schema_1.Schema.singleChoiceItem(DevicesType.SHORT_TERM_LVAD),
    schema_1.Schema.singleChoiceItem(DevicesType.SHORT_TERM_RVAD),
    schema_1.Schema.singleChoiceItem(DevicesType.SHORT_TERM_BI_VAD),
    schema_1.Schema.singleChoiceItem(DevicesType.OTHER_SHORT_TERM_VAD),
    schema_1.Schema.singleChoiceItem(DevicesType.HEART_WARE_HVAD),
    schema_1.Schema.singleChoiceItem(DevicesType.HEART_MATE_II),
    schema_1.Schema.singleChoiceItem(DevicesType.HEART_MATE3),
    schema_1.Schema.singleChoiceItem(DevicesType.JARVIK_2000),
    schema_1.Schema.singleChoiceItem(DevicesType.OTHER_LONG_TERM_VAD)
]);
const name = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../type} === "other_short_term_VAD" || {../type} === "other_long_term_VAD"`), schema_1.Schema.string());
const complicationsType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ComplicationsType.OBSTRUCTION),
    schema_1.Schema.singleChoiceItem(ComplicationsType.BLEEDING),
    schema_1.Schema.singleChoiceItem(ComplicationsType.EMBOLISM),
    schema_1.Schema.singleChoiceItem(ComplicationsType.DRIVELINE_INFECTION),
    schema_1.Schema.singleChoiceItem(ComplicationsType.INTRATHORACIC_INFECTION),
    schema_1.Schema.singleChoiceItem(ComplicationsType.OTHER)
]);
const date = schema_1.Schema.string().date();
const complications = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({ type: complicationsType, date }));
const devices = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../mcs} === "YES"`), schema_1.Schema.array()
    .default([])
    .minItems(1)
    .items(schema_1.Schema.object().properties({
    type: devicesType,
    name,
    complications
})));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ mcs, devices })
    .interpretation({ vocab: "htx", code: "heart_asist_system_therapy" })
    .tag({ vocab: "snomed", code: "64253000" });
